function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.612 24.278c1.33 0 2.048 1.396 2.048 2.766v3.431c0 .456-.37.825-.825.825h-3.857a.825.825 0 01-.837-.825v-3.537c0-1.158.864-2.66 1.955-2.66h1.516zm-9.11-7.701c1.33 0 2.048 1.396 2.048 2.766v3.432a.825.825 0 01-.838.824H6.868a.825.825 0 01-.838-.824v-3.538c0-1.157.865-2.66 1.955-2.66h1.516zm18.42 0C29.199 16.55 29.97 18 29.97 19.33v3.445a.825.825 0 01-.825.824h-3.857a.825.825 0 01-.838-.824v-3.538c0-1.157.865-2.66 1.956-2.66h1.516zM17.907 19.05a2.168 2.168 0 110 4.335 2.168 2.168 0 010-4.335zm.705-9.031c1.277 0 2.048 1.33 2.048 2.727v3.484c0 .456-.37.825-.825.825h-3.857a.825.825 0 01-.837-.825V12.68c0-1.157.864-2.66 1.955-2.66h1.516zm-9.829 1.303a2.168 2.168 0 110 4.336 2.168 2.168 0 010-4.336zm18.434 0a2.168 2.168 0 110 4.336 2.168 2.168 0 010-4.336zM17.907 4.7a2.168 2.168 0 110 4.336 2.168 2.168 0 010-4.336z",
  fill: "#98AAB3",
  fillRule: "nonzero"
});

var SvgClubs = function SvgClubs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClubs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clubs.b48011aa.svg";
export { ForwardRef as ReactComponent };